import { render, staticRenderFns } from "./ListDepartments.vue?vue&type=template&id=2788f31a&scoped=true&"
import script from "./ListDepartments.vue?vue&type=script&lang=ts&"
export * from "./ListDepartments.vue?vue&type=script&lang=ts&"
import style0 from "./ListDepartments.vue?vue&type=style&index=0&id=2788f31a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2788f31a",
  null
  
)

export default component.exports